import { jsx as t } from "react/jsx-runtime";
import a from "./index.es5576.js";
import { CompareBarChip as n } from "./index.es37.js";
const h = ({ chips: i, onChipClick: p }) => /* @__PURE__ */ t("div", { className: a.container, children: i.map(({ value: r, isSelected: o, ...m }) => /* @__PURE__ */ t(
  n,
  {
    isSearchFilter: !0,
    isSelected: o,
    ...m,
    onClick: (e) => {
      e.stopPropagation(), p(r, !o);
    }
  },
  r
)) });
export {
  h as AutoCompleteChips
};
//# sourceMappingURL=index.es2471.js.map
